export default __webpack_public_path__ + "static/media/favicon.1a51c0a1.ico";